import React, { useState } from "react";
import './style.scss';

export const HINT_POSITIONS = {
    RIGHT: 'right',
    LEFT: 'left',
    TOP: 'top',
    BOTTOM: 'bottom',
}

const CHint = ({ text = '', position = HINT_POSITIONS.RIGHT }) => {
    const [visible, setVisible] = useState(false);

    return <span
        className="c-hint"
        onMouseEnter={() => setVisible(text?.trim())}
        onMouseLeave={() => setVisible(false)}
    >
        <span className="c-hint-question">?</span>
        <span className={`c-hint-content c-hint-content-${position} ${visible ? 'c-hint-content-visible' : ''}`}>
            {text}
        </span>
    </span>
}

export default CHint;